import React from 'react';
import classnames from 'classnames';
import { dfs } from '../../utils';
import { Modal, Button, Select, ButtonGroup, Tooltip, Dnd, HotKeys } from '@platform/base';
import { getSysFieldid, theme, getTheme } from '@platform/api';
import './index.less';
import { DEFAULT_SORTER } from '../useSort/index';
require("../../../../static/font/iconfont.js");

const { Header, Body, Footer, Title } = Modal;

const Option = Select.Option;
const EMPTYVALUE = undefined;
const EMPTYLABEL = undefined;
const FLAG_SORT_ASC = 1;
const FLAG_SORT_DESC = -1;

export default function useGroupSort(Table) {
    return class GroupSortTable extends React.Component {
        constructor() {
            super();
            this.dragging = false;
            this.id = +new Date();
            this.state = {
                showModal: false,
                itemsInfo: [], // itemsInfo 结构 {value,label,order}  
                dragEnable: true, //是否可拖拽
                isBlack: getTheme(false) === 'black',
            };
        }

        componentDidMount() {
            theme.addListener(`table-theme-change-${this.id}`, this.themeChange);
        }

        render() {
            let { columns = [], locale, groupSortConfig, store } = this.props;
            let { showModal, isBlack } = this.state;
            let groupSortInfo = store.getGroupSortInfo();
            columns = dfs(columns, col => {
                let sortInfo = groupSortInfo.find(item => item.value === col.key) || {};
                return {
                    ...col,
                    title: (
                        <>
                            {col.title}
                            <Tooltip
                                placement="top"
                                overlay={locale['table_group_sort']}
                                delayShow={300}
                            >
                                <i
                                    className={classnames("header-icon", { 'fixed-icon': !!sortInfo.order })}
                                    onClick={() => { this.handleSortIconClick(col); }
                                    }
                                >
                                    {
                                        sortInfo.order === FLAG_SORT_ASC ?
                                            <svg
                                                className={`icon-shengxu`}
                                                style={{ width: "16px", height: "16px" }}
                                                aria-hidden="true"
                                            >
                                                <use xlinkHref={isBlack ? "#icon-a-liebiao-zuhepaixu-jiangxu1x" : "#icon-a-liebiao-zuhepaixu-shengxu1x"}></use>
                                            </svg> :
                                            <svg
                                                className={`icon-jiangxu`}
                                                style={{ width: "16px", height: "16px" }}
                                                aria-hidden="true"
                                            >
                                                <use xlinkHref={isBlack ? "#icon-a-liebiao-zuhepaixu-shengxu1x" : "#icon-a-liebiao-zuhepaixu-jiangxu1x"}></use>
                                            </svg>
                                    }

                                </i>
                            </Tooltip>
                        </>
                    ),
                };
            });

            return <React.Fragment>
                <Table
                    {...this.props}
                    columns={columns}
                    groupSortConfig={{
                        ...groupSortConfig,
                        onGroupSortClick: this.handleSortIconClick,
                    }}
                />
                <Modal
                    className="group-sort-modal"
                    visible={showModal}
                    onCancel={() => {
                        this.closeModal();
                    }}
                    onEnter={this.onModalLoad}
                    autoFocus={false}
                    modalAutoFocus={false} // base-modal里的属性
                    fieldid="filterPanel"
                    zIndex={1000}
                >
                    {<HotKeys
                        keyMap={{
                            handleSave: 'alt+Y',
                            handleClose: 'alt+N',
                        }}
                        handlers={{
                            handleClose: this.closeModal,
                            handleSave: () => {
                                this.closeModal();
                                this.handleGroupSort();
                            },
                        }}
                        className="colSetting-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        display="inline"
                    />}
                    <Header closeButton clsPrefix='wui-modal-header' onMouseEnter={this.onModalHeaderEnter} >
                        <Title
                            fieldid={getSysFieldid(`${locale['table_group_sort' /*组合排序*/]}`)}
                        >
                            {`${locale['table_group_sort' /*组合排序*/]}`}
                            <Tooltip
                                placement="top"
                                overlay={locale['table_group_sort_tip'] /**支持当前页组合排序，可调整分页数扩大排序范围 */}
                                delayShow={300}
                            >
                                <i className="iconfont icon-bangzhutishi icon-group-sort-tip" />
                            </Tooltip>
                        </Title>
                        {/* </div> */}
                    </Header>
                    <Body clsPrefix='wui-modal-body' className="modal-body">
                        <p className="condition-tip" >{locale['table0056' /*多个条件按条件顺序逐层排序*/]} </p>
                        {this.renderConditionItem()}
                        {this.renderOperateItem()}
                    </Body>
                    <Footer clsPrefix='wui-modal-footer'>
                        <ButtonGroup>
                            <Button
                                colors="primary"
                                onClick={() => {
                                    this.closeModal();
                                    this.handleGroupSort();
                                }}
                                style={{ marginRight: '8px' }}
                                className="button-primary"
                                fieldid={getSysFieldid("group-sort-sure")}
                            >
                                {locale['table_sure']/*确定 */}
                                (
                                {<span style={{ textDecoration: 'underline' }}>Y</span> /*Y*/}
                                )
                            </Button>
                        </ButtonGroup>
                        <Button
                            onClick={() => {
                                this.closeModal();
                            }}
                            fieldid={getSysFieldid("group-sort-cancel")}
                        >
                            {locale['table_cancel']/*取消 */}
                            (
                            {<span style={{ textDecoration: 'underline' }}>N</span> /*(N)*/}
                            )
                        </Button>
                    </Footer>
                </Modal>
            </React.Fragment>;
        }

        componentWillUnmount() {
            theme.removeListener(`table-theme-change-${this.id}`);
        }

        themeChange = theme => {
            this.setState({ isBlack: theme === 'black' });
        }

        //打开排序弹窗
        handleSortIconClick = col => {
            let { store } = this.props;
            let { itemsInfo } = this.state;
            let sortInfo = store.getSortInfo();
            let groupSortInfo = store.getGroupSortInfo();
            if (this.isUnSelect(col.attrcode)) { //增加
                this.addItem({
                    value: col.attrcode,
                    label: col.label,
                    order: sortInfo.get(col.attrcode) || FLAG_SORT_ASC,
                }, false);
            } else { //修改
                let targetIndex;
                this.state.itemsInfo.forEach((item, index) => {
                    if (item.value === col.attrcode) {
                        targetIndex = index;
                    }
                });
                this.changItem({
                    value: col.attrcode,
                    label: col.label,
                    order: sortInfo.get(col.attrcode) || FLAG_SORT_ASC,
                }, targetIndex, false);
            }
            itemsInfo = itemsInfo.map(item => {
                return { ...item, order: sortInfo.get(item.value) || groupSortInfo.find(info => info.value === item.value)?.order || FLAG_SORT_ASC }; //更新order，保证order是最新的
            });
            //只留下当前点击的列和已经组合排序过的列
            itemsInfo = itemsInfo.filter(item => groupSortInfo.some(sortItem => sortItem.value === item.value) || item.value === col.attrcode);

            this.setState({
                showModal: true,
                itemsInfo,
            });
        }

        onSelectChange = (value, oldValue, option, index) => {
            let { itemsInfo } = this.state;
            itemsInfo[index] = {
                ...itemsInfo[index],
                value,
                label: option.children,
            };
            this.updateItems(itemsInfo);
        }

        addItem = (itemInfo = {}, forceUpdate = true) => {
            this.state.itemsInfo.push(itemInfo);
            forceUpdate && this.updateItems(this.state.itemsInfo);
            requestAnimationFrame(() => {
                document.querySelector('.group-sort-modal .base-modal-body').scrollTop = 9999;//滚动条下拉到末尾
            });

        }

        changItem = (item, index, forceUpdate = true) => {
            let { itemsInfo } = this.state;
            itemsInfo[index] = { ...itemsInfo[index], ...item };
            forceUpdate && this.updateItems(itemsInfo);
        }

        exchangeItem = (startIndex, endIndex) => {
            let { itemsInfo } = this.state;
            [itemsInfo[startIndex], itemsInfo[endIndex]] = [itemsInfo[endIndex], itemsInfo[startIndex]];
            console.log(itemsInfo);
            this.setState({ itemsInfo });
        }

        clearSingleItem = (e, index) => {
            this.state.itemsInfo.splice(index, 1);
            this.updateItems(this.state.itemsInfo);
        }

        clearAllItem = () => {
            this.updateItems([]);
        }

        isUnSelect = compareValue => {
            let { itemsInfo } = this.state;
            let itemValue = new Set();
            itemsInfo.forEach(item => {
                itemValue.add(item.value);
            });
            return !itemValue.has(compareValue);
        }

        updateItems = items => {
            this.setState({ itemsInfo: items });
        }

        handleIconEnter = () => {
            this.updateDragState(true);
        }

        updateDragState = enable => {
            this.setState({ dragEnable: enable });
        }

        onItemDown = e => {
            let iconHandle = document.querySelector('.icon-group-sort-drag');
            if (e.target.className !== iconHandle.className) { //不允许拖拽  
                this.updateDragState(false);
            } else {
                this.transformStyle();//拖拽把手时,将样式改为left/right定位
            }
        }
        //拖拽把手时,将样式改为left/right定位 否则transform定位会导致偏移
        transformStyle = () => {
            this.modalDom = document.querySelector('.group-sort-modal > .wui-modal-resizbox');
            let modalOffset = this.modalDom.style.transform.match(/\d+/g);
            if (modalOffset) {
                let [left, top] = [modalOffset[2], modalOffset[3]];
                this.modalDom.style.transform = '';
                this.modalDom.style.left = left + 'px';
                this.modalDom.style.top = top + 'px';
            }
        }

        //此时可能会拖拽弹窗行为,将样式改为transform
        onModalHeaderEnter = () => {
            this.modalDom = document.querySelector('.group-sort-modal > .wui-modal-resizbox');
            if (this.modalDom.style.transform == '' && !this.dragging) {
                let [left, top] = [this.modalDom.style.left, this.modalDom.style.top];
                this.modalDom.style.left = 0;
                this.modalDom.style.top = 0;
                this.modalDom.style.transform = `translate(0px, 0px)  translate(${left}, ${top})`;
            }
        }

        //拖拽开始
        onDragStart = () => {
            this.dragging = true;
        };
        //拖拽结束
        onDragEnd = dragInfo => {
            let { source, destination } = dragInfo,
                { index: startIndex } = source,
                { index: endIndex } = destination;
            this.exchangeItem(startIndex, endIndex);
            this.dragging = false;
        };

        //  操作组合排序条件
        renderOperateItem = () => {
            let { locale } = this.props;
            return <div className='item-operate'>
                <div
                    fieldid={getSysFieldid("group-sort-add")}
                    className='add'
                    onClick={() => this.addItem({ value: EMPTYVALUE, label: EMPTYLABEL, order: FLAG_SORT_ASC })}
                >
                    <i className='icon-add iconfont icon-yibiaopan-xinzeng'></i>
                    <span className='text-add'>{locale['table_add_condition'] /*添加条件*/}</span>
                </div>
                <div
                    fieldid={getSysFieldid("group-sort-clear")}
                    className='clear'
                    onClick={this.clearAllItem}
                >
                    <i className='icon-clear iconfont icon-gsbjq-shanchu'></i>
                    <span className='text-clear'>{locale['table0030'] /*清空*/}</span>
                </div>
            </div>;
        }

        isSortCol = col => {
            let { layoutMode } = this.props;
            return (layoutMode === "flat" ? !col.isChildCol : true) && col.attrcode !== "opr" && !col.children && col.sortable && this.isUnSelect(col.attrcode);
        }
        //渲染组合排序条件
        renderConditionItem = () => {
            let { itemsInfo, dragEnable } = this.state;
            let { store, locale } = this.props;
            let visibleCols = store.getVisibleColumns().filter(col => this.isSortCol(col));
            let list = itemsInfo.map((item, index) => {
                let asc_colors = item.order === FLAG_SORT_ASC ? "primary" : "secondary";
                let desc_colors = item.order === FLAG_SORT_DESC ? "primary" : "secondary";
                return <div className="item-wrapper" key={index} onMouseDown={this.onItemDown}>
                    <div>
                        <i
                            className='icon-group-sort-drag handle iconfont icon-tuozhuai1'
                            onMouseEnter={this.handleIconEnter}
                        >

                        </i>
                        <Select
                            fieldid={getSysFieldid("group-sort-select")}
                            showClear={false}
                            value={item.label}
                            className="item-select"
                            onChange={(value, oldValue, option) => this.onSelectChange(value, oldValue, option, index)}
                        >
                            {visibleCols.map(col => {
                                return <Option key={col.attrcode}>{col.label}</Option>;
                            })}
                        </Select>
                    </div>

                    <div>
                        <Button
                            fieldid={getSysFieldid("group-sort-asc")}
                            colors={asc_colors}
                            className="item-button-asc"
                            onMouseDown={e => e.stopPropagation()}
                            onClick={() => this.changItem({ order: FLAG_SORT_ASC }, index)}
                        >
                            {locale['table_asc'] /*升序*/}
                        </Button>
                        <Button
                            fieldid={getSysFieldid("group-sort-desc")}
                            colors={desc_colors}
                            className="item-button-desc"
                            onMouseDown={e => e.stopPropagation()}
                            onClick={() => this.changItem({ order: FLAG_SORT_DESC }, index)}
                        >
                            {locale['table_desc'] /*降序*/}
                        </Button>
                        <i
                            fieldid={getSysFieldid("group-sort-del")}
                            className='icon-delete disabled-drag iconfont icon-guanbi2'
                            onMouseDown={e => e.stopPropagation()}
                            onClick={e => this.clearSingleItem(e, index)}
                        >

                        </i>
                    </div>
                </div>;

            });
            return <div className="body-content" style={{ position: 'relative' }}>
                {
                    (dragEnable && list.length) ?
                        <Dnd
                            list={list}
                            onStart={this.onDragStart}
                            onStop={this.onDragEnd}
                            draggableCancel="disabled-drag"
                            type="vertical"
                            dragingClass="dragging"
                        >
                        </Dnd>
                        :
                        list
                }

            </div>;
        }

        closeModal = () => {
            this.setState({ showModal: false });
        }

        handleGroupSort = () => {
            let { itemsInfo } = this.state;
            let { GroupSortConfig = {} } = this.props;
            let { onSort } = GroupSortConfig;
            onSort?.(itemsInfo);
        }
    };
}

useGroupSort.displayName = 'useGroupSort';
useGroupSort.dependence = [];
useGroupSort.hooks = function () {
    //sortInfo [{},{value,label,order}]
    this._groupSort = rowKeys => {
        let sortInfo = this.store.groupSortInfo || [],
            visibleRowKeysSet = new Set(rowKeys);

        if (!sortInfo.length) { return rowKeys; }
        this.clearSortInfo(); //清空排序信息

        // 单来源，取主的sorter
        let mainColMap = {};

        try {
            if (this.getRelation) {
                let id = this.store.meta.mainId,
                    relation = this.getRelation(),
                    mainId = relation.main[id];

                mainColMap = this.store.meta[mainId].items.reduce((map, item) => {
                    map[item.attrcode] = item;
                    return map;
                }, {});
            }
        } catch (e) {
            console.error(e);
        }
        
        const multiSorter = (rowKeyA, rowKeyB) => {
            let rowA = this.getRowData(rowKeyA),
                rowB = this.getRowData(rowKeyB);

            if (!visibleRowKeysSet.has(rowKeyA) || !visibleRowKeysSet.has(rowKeyB)) {
                return 0;
            }

            for (let i = 0; i < sortInfo.length; i++) {
                let { value: colKey, order } = sortInfo[i],
                    col = this.getColumnProps(colKey),
                    mainCol = mainColMap[colKey],
                    sorter = col?.sorter || mainCol?.sorter || DEFAULT_SORTER.bind(null, col);

                let res = order === FLAG_SORT_ASC ? sorter(rowA, rowB) : sorter(rowB, rowA);
                
                if (res === 0) {
                    continue;
                } else {
                    return res;
                }
            }

            return 0;
        };

        rowKeys.sort(multiSorter);
        this.store.rowKeys.sort(multiSorter);

        // 同步至其他页签
        try {
            if (this.getRelation && this.getPageScope()) {
                let id = this.store.meta.mainId,
                    relation = this.getRelation(),
                    pageScope = this.getPageScope(),
                    share = relation.share[id];

                share.forEach(shareId => {
                    if (shareId === id) {
                        return;
                    }

                    /**
                     * 单来源多页签时，要把当前的排序结果同步给其他页签，具体为：
                     * 1、同步sortInfo
                     * 2、同步visibleRowKeys
                     * 3、同步rowKeys
                     * 4、调用_updateDataIndex
                     * 5、调用_updateViewIndex和updateRowsHeight
                     * 
                     * 其中：
                     * 1是模拟setSortInfo
                     * 234是模拟_sort
                     * 5是模拟_updateVisibleRows
                     */

                    let instance = pageScope.cardTableDataSource[shareId].getInstance();

                    instance.store.sortInfo = new Map();
                    instance.store.groupSortInfo = sortInfo;
                    instance.store.visibleRowKeys = [...rowKeys];
                    instance.store.rowKeys = [...this.store.rowKeys];
                    instance._updateDataIndex();
                    instance.updateRowsHeight({ shouldUpdate: false });
                });
            }
        } catch (e) {
            console.error(e);
        }

        this._updateDataIndex();
        
        return rowKeys;
    };
    return {
        getGroupSortInfo: () => {
            return JSON.parse(JSON.stringify(this.store.groupSortInfo || '')) || [];
        },
        setGroupSortInfo: (sortInfo = []) => {
            this.store.groupSortInfo = [...sortInfo];
            this.store.sortInfo = new Map();

            this._updateVisibleRows(); // 会调用this.groupSort
            this.forceUpdate();
        },
        clearGroupSortInfo: () => {
            this.store.groupSortInfo = [];
        },

    };
};
useGroupSort.propsGenerator = function (props) {
    let { GroupSortConfig = {}, store } = props;
    return {
        ...props,
        GroupSortConfig: {
            ...GroupSortConfig,
            onSort: sortInfo => {
                store.setGroupSortInfo(sortInfo);
            },
        },
    };
};